export default __webpack_public_path__ + "static/media/tabActService.4259ba45.svg";